import useFamilyAccess from './features/useFamilyAccess'
import useGoalsAccess from './features/useGoalsAccess'

export enum Features {
  FAMILY,
  GOALS
}

const useFeatures = (): Record<Features, boolean> => {
  const hasFamily = useFamilyAccess()
  const hasGoals = useGoalsAccess()

  return {
    [Features.FAMILY]: hasFamily,
    [Features.GOALS]: hasGoals
  }
}

export default useFeatures
